import React, { useContext, useEffect, memo, useRef, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import SitesAreaFilter from "./SitesAreaFilter";
import { ToggleSwitch, ToggleTitleWrapper } from "../styled/ToggleTile.styled";
import { clusterDefaultZoomLvl, Names_For_Filter_OPs } from "../../constants/WebMap";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import SitesDetailsTile from "./SitesDetailTile";
import { fetchOprtSiteCounts } from "../../services/api/siteService";
import { convertArrayToStringWithDelimeter } from "../../utils/helper";

const OperatorSitesCards = ({
  isSitesChecked = false,
  isOpSitesChecked = false,
  handleOpSitesToggle = () => {},
  opGAPerm
}) => {
  const cancelToken = useRef();
  const TOForSiteCount = useRef(); // api timeout

  const {
    mapZoomLevel,
    siteZoom,
    appliedFilters,
    opSiteAreaToggle,
    setOpSiteAreaToggle,
    selectedOperatorSiteOperator,
    setSelectedOperatorSiteOperator,
    geohashNE,
    geohashSW,
    mapRef,
    edotcoSitePerm,
    operatorsPermittedOpSite = []
  } = useContext(WebMapContext);

  const [siteCounts, setSiteCounts] = useState([]);
  const [viewportNE, setViewportNE] = useState([]);
  const [viewportSW, setviewportSW] = useState([]);
  const [operatorData, setOperatorData] = useState([]);

  const getSitesCounts = useCallback(async () => {
    if (typeof cancelToken.current != typeof undefined) {
      cancelToken.current.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    cancelToken.current = axios.CancelToken.source();
    clearTimeout(TOForSiteCount.current);

    TOForSiteCount.current = setTimeout(async () => {
      try {
        const { data } = await fetchOprtSiteCounts({
          countryCode: appliedFilters.countryCode,
          quarter: appliedFilters.quarter,
          year: appliedFilters.year,
          adL: opSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.level : null,
          adLVal: opSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.levelVal : null,
          northEast: convertArrayToStringWithDelimeter(opSiteAreaToggle && geohashNE.length ? geohashNE : viewportNE, "_"),
          southWest: convertArrayToStringWithDelimeter(opSiteAreaToggle && geohashSW.length ? geohashSW : viewportSW, "_"),
        }, cancelToken.current);
        setSiteCounts(data);
      } catch (err) {
        console.log("Error while filtering site counts", err);
        toast.error(err.message, { theme: "colored" });
      }
    }, TOForSiteCount);
  },[appliedFilters.countryCode, appliedFilters.level, appliedFilters.levelVal, appliedFilters.quarter, appliedFilters.year, geohashNE, geohashSW, opSiteAreaToggle, viewportNE, viewportSW])


  useEffect(() => {
    const map = mapRef?.current;
    let listener;
    if (map) {
      listener = map.addListener('idle', () => {
        const bounds = mapRef.current.getBounds();
        setViewportNE([bounds.getNorthEast().lng(), bounds.getNorthEast().lat()]);
        setviewportSW([bounds.getSouthWest().lng(), bounds.getSouthWest().lat()]);
      });
    }

    return () => {
      if (map && listener) window.google.maps.event.clearListeners(map, 'idle', listener);
    };
  }, []);

  // get counts for view-port
  useEffect(() => {
    if (!opSiteAreaToggle || !appliedFilters.level) {
      if (isSitesChecked && isOpSitesChecked &&
        (mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) &&
        viewportSW.length) {
        getSitesCounts();
      } else setSiteCounts([]);
    }
  }, [viewportSW, opSiteAreaToggle, isOpSitesChecked, isSitesChecked, siteZoom, appliedFilters.level, mapZoomLevel, getSitesCounts]);

  // get counts for area
  useEffect(() => {
    if (opSiteAreaToggle && appliedFilters.level) {
      if (isSitesChecked && isOpSitesChecked) {
        getSitesCounts();
      } else setSiteCounts([]);
    }
  }, [appliedFilters.level, appliedFilters.levelVal, opSiteAreaToggle, isOpSitesChecked, isSitesChecked, getSitesCounts]);

  useEffect(() => {
    setOperatorData(operatorsPermittedOpSite);
  }, [isSitesChecked, operatorsPermittedOpSite]);

  const onChangeOperatorSiteOperator = (val) => {
    setSelectedOperatorSiteOperator(val);
  };

  const onChangeOperatorAreaFilter = () => {
    setOpSiteAreaToggle(!opSiteAreaToggle)
  }

  return (
    <>
      { isSitesChecked && (
        <Grid
          container
          item
          style={{
            justifyContent: "space-between",
            textAlign: "left",
            font: "normal normal normal 13px/18px Open Sans",
            letterSpacing: "0px",
            color: "black",
            opacity: "1",
            padding: "0px 10px 0px 10px",
            margin: edotcoSitePerm?.is_enable === true ? "0px 0px 8px 0px" : "8px 0px",
          }}
        >
          <ToggleTitleWrapper main>Operator Sites</ToggleTitleWrapper>
          <ToggleSwitch
            checked={isOpSitesChecked}
            onChange={handleOpSitesToggle}
          />
          {isOpSitesChecked && (
            <>
            {opGAPerm?.is_enable === true && (
              <SitesAreaFilter
                siteAreaToggle={opSiteAreaToggle}
                appliedFilters={appliedFilters}
                onChangeGeoAreaFilter={onChangeOperatorAreaFilter}
              />
            )}
              <SitesDetailsTile
                title="Operator Existing"
                selectedOperator={selectedOperatorSiteOperator}
                onchangeOperator={onChangeOperatorSiteOperator}
                counts={(mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) ? siteCounts : []}
                showCounts={true}
                permitedOperatorData={operatorData}
              />
            </>
          )}
        </Grid>
      )}</>
  );
}

export default memo(OperatorSitesCards);
